import axios from 'axios';
import Cookies from 'js-cookie';

interface AppLoginConfig {
	loginEntryPoints: Record<string, string>;
	regionApiUrl: string;
}

interface RegionResponse {
	region: string;
}

declare global {
	interface Window {
		mcflyAppLogin: AppLoginConfig;
	}
}

const appLoginConfig = window.mcflyAppLogin;

if (appLoginConfig.regionApiUrl && Object.keys(appLoginConfig.loginEntryPoints).length) {
	const redirectByRegion = (region = '') => {
		if (region && region in appLoginConfig.loginEntryPoints) {
			window.location.assign(appLoginConfig.loginEntryPoints[region]);
		} else {
			window.location.assign(appLoginConfig.loginEntryPoints[Object.keys(appLoginConfig.loginEntryPoints)[0]]);
		}
	};

	const cookieLoginURL = Cookies.get('MP_LOGIN_URL');
	if (cookieLoginURL) {
		window.location.assign(cookieLoginURL);
	} else {
		axios
			.get<RegionResponse>(appLoginConfig.regionApiUrl)
			.then((response) => {
				const region = response.data.region.toLowerCase();
				redirectByRegion(region);
			})
			.catch(() => {
				redirectByRegion();
			});
	}
}
